var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74245 10.7575C2.97676 10.9918 3.35666 10.9918 3.59098 10.7575L8.50005 5.84843L13.4091 10.7575C13.6434 10.9918 14.0233 10.9918 14.2576 10.7575C14.492 10.5232 14.492 10.1433 14.2576 9.90897L8.92431 4.57564C8.69 4.34132 8.3101 4.34132 8.07578 4.57564L2.74245 9.90897C2.50813 10.1433 2.50813 10.5232 2.74245 10.7575Z",
    fill: "#5A5C63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.4067e381b7788713b82eccdb6e1e7e2e.svg";
export { ForwardRef as ReactComponent };